module.exports = __webpack_public_path__ + "img/tc-btn-cj.2b3032fe.png";